import * as styles from './Hint.module.css'

import React from 'react'

interface Props {
  children: React.ReactNode
}

export const Hint: React.FC<Props> = (props) => {
  const { children } = props

  return <div className={styles.hint}>{children}</div>
}
